import { Component, computed, effect, inject, signal, untracked } from "@angular/core"
import { Classification, Content, ContentType, LngLat } from "redlineLibs"
import { RegionProperties } from "../map/map.type"
import { RouterLink } from "@angular/router"
import { MapService } from "../map/map.service"
import { HolcAttributionDialogComponent } from "../shared/dialogs/holc-attribution.dialog.component"
import { debounceSignal } from "@ddtmm/angular-signal-generators"
import { PageToolbarService } from "../page-toolbar.service"
import { RedlineMapDetailsComponent } from "./redline-map-details.component"
import { UiInheritDirective } from "ui-inherit"
import { EditorComponent } from "../editor/editor.component"
import { ProfileProgress } from "../user-profile/profile.model"
import { ProfileService } from "../user-profile/profile.service"
import { RouteService } from "../../services/route.service"
import { FirestoreReadService } from "../content/firestore-read.service"
import { regionsData } from "redlineLibs"
import { RegionsEnum } from "redlineLibs"
import { HelpTipsComponent } from "feature/redline/help-tips"
import { RegionsService } from "../../regions/regions.service"
import { NextSectionButtonComponent } from "../shared/next-section-button.component"
import { WA_LOCAL_STORAGE } from "@ng-web-apis/common"
import { RedlineMapService } from "./redline-map.service"
import { MapGoogleComponent } from "../map/map-google.component"
import { RolesEnum } from "redlineLibs"

@Component({
  imports: [
    MapGoogleComponent,
    RouterLink,
    UiInheritDirective,
    HolcAttributionDialogComponent,
    RedlineMapDetailsComponent,
    EditorComponent,
    HelpTipsComponent,
    NextSectionButtonComponent,
  ],
  standalone: true,
  template: `
    @if (!visited()) {
      <lib-feature-help-tips (cancelAndClose)="visitConfirmed()"/>
    }

    @if (showNewContentEditor() && newContent(); as newContent) {
      <e2e-editor
        context="contributor"
        [content]="newContent"
        [isNewContent]="true"
        (cancelAndClose)="showNewContentEditor.set(false)"
        inherit
      />
    }

    <div
      class="column"
      style="height: 100vh"
    >
      <!--      <e2e-page-toolbar/>-->
      <div
        #pageToolbarPlaceholder
        style="width: 100%"
        [style.height.px]="pageToolbarHeight()"
      ></div>
      <div class="column" style="align-items: center">
        <div style="font-size: 22px; font-weight: 600">
          {{ redliningTitle() }}
        </div>
      </div>

      <div class="row" style="flex-grow: 1; align-items: normal">
        <div style="flex-grow: 1">
            <e2e-map-google
              [scrollZoom]="true"
              [regionDatum]="regionDatum()"
              (mapClick)="mapClick($event)"
              (regionClick)="regionClick($event)"
              inherit
            />
        </div>
      </div>
      <button routerLink="/timeline" style="width: 100%; background: #f3f3f3">
        <e2e-next-section-button/>
      </button>
    </div>

    @if (showAttributionModal()) {
      <e2e-holc-attribution-dialog (confirmed)="showAttributionModal.set(false)"/>
    }

    <e2e-redline-map-details
      [showMapModal]="showMapModal()"
      (hideMapModal)="setShowMapModal(false)"
      (showAttributionModal)="showAttributionModal.set(true)"
      (createNewContent)="createNewContent(markerLocation())"
    />
<!--      [showContent]="showContent()"-->
  `,
  selector: "e2e-redline-map",
})
export class RedlineMapComponent {
  private localStorage = inject(WA_LOCAL_STORAGE)
  private mapService = inject(MapService)
  private pageToolbarService = inject(PageToolbarService)
  private profileService = inject(ProfileService)
  private routeService = inject(RouteService)
  private firestoreReadService = inject(FirestoreReadService)
  private regionService = inject(RegionsService)
  private redlineMapService = inject(RedlineMapService)

  brandHeader = this.regionService.brandHeader

  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  newContent = signal<Content | undefined>(undefined)
  // handsetBreakpointObserver = toSignal(this.breakpointObserver.observe([Breakpoints.Handset]))
  // handset = computed(() => this.handsetBreakpointObserver()?.matches)
  markerLocation = this.mapService.markerLocation
  // showContentDebounced = debounceSignal(0, 1000)
  showAttributionModal = signal(false)
  // showContent = signal(true)
  showMapModal = this.mapService.showMapModal

  regionDatum = computed(() =>
    regionsData[regionsData[this.routeService.region()].redliningRegion]
  )

  redliningTitle = computed(() =>
    this.regionDatum().titleRedlining
  )

  showNewContentEditor = signal(false)
  visited = this.redlineMapService.visited

  constructor() {
    this.mapService.resetNewCenter()
    effect(() => this.pageToolbarHeight()) // required in order to trigger template refresh when pageToolbarHeight changes
    this.redlineMapService.setVisited(this.localStorage.getItem("visitedRedlineMap")?.toLowerCase() === "true")
    // effect(() => {
    //   if (this.mapService.markerLocation()) {
    //     untracked(() => {
          // this.showContentDebounced.set(Date.now())
          // this.showContent.set(false)
        // })
      // }
    // })
    // effect(() => {
    //   if (this.showContentDebounced()) {
        // untracked(() => this.showContent.set(true))
      // }
    // })
  }

  setShowMapModal(showMapModal: boolean) {
    this.mapService.setShowMapModal(showMapModal)
  }

  visitConfirmed() {
    this.redlineMapService.setVisited(true)
    this.localStorage.setItem("visitedRedlineMap", "true")
  }

  // mapRegionProperties = signal<RegionProperties | null>(null)

/*
  reset() {
    this.mapService.setMarkerLocation(undefined)
    this.mapService.setStoryProperties({ authorUserName: "", storyId: "", text: "", filePath: "" })
    // this.mapRegionProperties.set(null)
  }
*/

  setMarkerLocation(location: LngLat) {
    this.mapService.setMarkerLocation(location)
  }

  mapClick(markerLocation: LngLat) {
    // console.log("mapClick")
    this.mapService.unsetRegionProperties()
    this.mapService.unsetStoryProperties()
    this.mapService.setShowMapModal(true)
    // this.reset()
    this.setMarkerLocation(markerLocation)
    /*
        if (this.storyMode()) {
          this.localMapsService.setMarkerLocation(markerLocation)
        }
    */
  }

/*
  contentMarkerClick(storyProperties: StoryProperties) {
    // console.log("contentMarkerClick")
    // this.reset()
    this.mapService.setStoryProperties(storyProperties)
  }
*/

  regionClick(event: { lngLat: LngLat; properties: RegionProperties | undefined }) {
    // console.log("regionClick")
    // console.log(event.properties)
    if (event.properties) {
      // ?.clarifying_remarks) {
      // console.log(event.properties)
      this.mapService.setRegionProperties(event.properties)
    }
    // this.reset()
    // this.mapRegionProperties.set(event.properties)
  }

  /*
    switchToDiscoverMode() {
      this.modeSwitch(LocalMapsMode.DISCOVER)
    }

    switchToLearnMode() {
      this.modeSwitch(LocalMapsMode.LEARN)
    }

    switchToStoryMode() {
      this.modeSwitch(LocalMapsMode.STORY)
    }

    modeSwitch(localMapsMode: LocalMapsMode) {
      this.reset()
      this.localMapsService.setregionProperties(null)
      this.routeService.changeFragment(localMapsMode.toLowerCase())
    }
  */

  createNewContent(markerLocation: LngLat | undefined) {
    if (markerLocation) {
      const user = {
        id: this.profileService.userId(),
        name: this.profileService.userName(),
        role: this.profileService.getUserRole(),
        region: this.profileService.region(),
      }

      if (!(user.id && user.name && user.role)) {
        this.routeService.changeRoute([], { p: "my-account-login", s: "" })
        return
      }

      if (this.profileService.profileStatus().progress === ProfileProgress.INCOMPLETE) {
        this.routeService.changeRoute([], { p: "my-account-login", s: "" })
        // this.routeService.changeRoute([], { p: "my-account-profile", s: "" })
        return
      }

      const content = this.buildNewContent(markerLocation, user)
      if (content) {
        this.newContent.set(content)
        this.showNewContentEditor.set(true)
      }
    }
  }

  buildNewContent(location: LngLat, user: { id: string, name: string, role: RolesEnum, region: RegionsEnum }) {
    const newContent = this.firestoreReadService
      .newContent(
        user,
        [ContentType.CONTRIBUTED, ContentType.LOCAL_MAP],
        Classification.CONTRIBUTED
      )
    return <Content>{
      ...newContent,
      settings: {
        ...newContent.settings,
        location: {
          lat: location.lat,
          lng: location.lng,
        },
      },
    }
  }

}

/**
 *
 *
 *   styles: `
 *     .number {
 *       border: 1px solid white;
 *       border-radius: 2em;
 *       width: 2em;
 *       height: 2em;
 *       line-height: 2em;
 *       text-align: center;
 *       font-size: 1.2em;
 *       color: white;
 *       box-sizing: border-box;
 *       flex: 0 0 2em;
 *     }
 *
 *     .header {
 *       font-size: 1.2em;
 *       line-height: 2em;
 *       font-weight: bold;
 *       color: white;
 *       flex: 1;
 *     }
 *   `,
 *
 *
 *         <!--
 *                 <b>
 *                   {{ region.location || region.name }}
 *                   {{ region.security_grade }}
 *                   {{ region.area_number }}
 *                   {{ region.date }}
 *                 </b>
 *                 <p>
 *                   <i>
 *                     Class and Occupation
 *                   </i>
 *                   <br/>
 *                   {{ region.occupation_or_type }}
 *                 </p>
 *                 <p>
 *                   <i>
 *                     Foreign Families (Nationality)
 *                   </i>
 *                   <br/>
 *                   {{ region.foreign_born_percent }}
 *                 </p>
 *                 <p>
 *                   <i>
 *                     Negro Infiltration
 *                   </i>
 *                   <br/>
 *                   {{ region.negro_percent || '-' }}
 *                 </p>
 *                 <p>
 *                   <i>
 *                     Shifting or Infiltration
 *                   </i>
 *                   <br/>
 *                   {{ region.infiltration_of || '-' }}
 *                 </p>
 *                 <p>
 *                   <i>
 *                     Description
 *                   </i>
 *                   <br/>
 *                   {{ region.clarifying_remarks }}
 *                 </p>
 *         -->
 *
 *
 *
 *             <!--
 *             <div
 *               class="column red-paper-texture"
 *               style="padding: 10px; width: 320px"
 *             >
 *
 *               &lt;!&ndash;
 *                         @if (learnMode() || !handset() || true) {
 *                           <section
 *                             class="column"
 *                             [style.flex]="learnMode() ? 1 : 0"
 *                           >
 *                             <div
 *                               class="row"
 *                               (click)="switchToLearnMode()"
 *                             >
 *                               <div class="number">
 *                                 1
 *                               </div>
 *                               <div class="header">
 *                                 Learn about Redlining
 *                               </div>
 *                             </div>
 *                             @if (learnMode()) {
 *                               <e2e-local-map-learn/>
 *                             }
 *                           </section>
 *                         }
 *               &ndash;&gt;
 *
 *               &lt;!&ndash;
 *                         @if (storyMode() || !handset() || true) {
 *                           <section
 *                             class="column"
 *                             [style.flex]="storyMode() ? 1 : 0"
 *                           >
 *                             <div
 *                               class="row"
 *                               (click)="switchToStoryMode()"
 *                             >
 *                               <div class="number">
 *                                 2
 *                               </div>
 *                               <div class="header">
 *                                 Tell Your Story
 *                               </div>
 *                             </div>
 *                             @if (storyMode()) {
 *                               <e2e-local-map-story/>
 *                             }
 *                           </section>
 *                         }
 *               &ndash;&gt;
 *
 *               &lt;!&ndash;
 *                         @if (discoverMode() || !handset() || true) {
 *                           <section
 *                             class="column"
 *                             [style.flex]="discoverMode() ? 1 : 0"
 *                           >
 *                             <div
 *                               class="row"
 *                               (click)="switchToDiscoverMode()"
 *                             >
 *                               <div class="number">
 *                                 3
 *                               </div>
 *                               <div class="header">
 *                                 Discover Stories
 *                               </div>
 *                             </div>
 *                             @if (discoverMode()) {
 *                               <e2e-local-map-discover/>
 *                             }
 *                           </section>
 *                         }
 *               &ndash;&gt;
 *
 *               <button routerLink="/timeline" style="margin-top: auto">
 *                 <e2e-next-section-button/>
 *               </button>
 *
 *             </div>
 *     -->
 */
